export default __webpack_public_path__ + "static/media/icon-ic-edit.8fc5d694.svg";